var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"width-100 height-100 max_box"},[_c(_vm.currentView,{ref:"coms",tag:"component",attrs:{"cardData":_vm.cardData},on:{"playEnd":function($event){return _vm.playNext()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }